<template>
    <v-container>
        <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>

        <v-row>
            <v-col md="3" offset-md="4">
                <v-sheet>
                    <v-col cols="">
                        <FormBuilder
                            :formElements="formElements"
                            @formSubmit="formSubmit"
                            :useCancel="false"
                            :loading="showLoader">
                                <v-col cols="12">
                                    <DateTimePickerFilter
                                        :error="dateErrors"
                                        :blockedIntervals="blockedIntervals"
                                        v-model="dateObj"
                                        >
                                    </DateTimePickerFilter>
                                </v-col>
                        </FormBuilder>
                    </v-col>
                </v-sheet>
            </v-col>
        </v-row>


    </v-container>
</template>

<script>
import httpClient from '@/api/httpClient'
import DateTimePickerFilter from '@/components/v2/DateTimePickerFilter'
import store from '@/store/store'

export default {
    components: {
        DateTimePickerFilter
    },
    data() {
        return {
            itemsForNavigation: [
                {
                    text: this.$t('navigation.settings.Settings'),
                    disabled: true
                },
                {
                    text: this.$t('navigation.settings.Mileage Cleanup'),
                    disabled: true
                }
            ],
            showLoader: false,
            dateObj: {},
            dateErrors: '',
            blockedIntervals: [],
            formElements: [
                {
                    key: 'vehicleId',
                    component: 'v-autocomplete',
                    label: '$vehicle',
                    rules: 'required',
                    dataSource: {
                        endpoint: '/vehicles'
                    }
                },
                {
                    key: 'mileage',
                    type: "number",
                    rules: 'required',
                    label: '$mileageToBeDeleted'
                },
                {
                    key: 'operator',
                    component: 'v-autocomplete',
                    label: '$operator',
                    dataSource: [
                        { text: '$lessThan', value: 1 },
                        { text: '$greaterThan', value: 2} 
                    ],
                    rules: "required"
                }
            ]
        }
    },
    methods: {
        formSubmit(item) {
            var that = this
            that.showLoader = true
            httpClient({
                url: '/Mileage/mileageCleanup',
                method: 'POST',
                data: {
                    ...item,
                    ...this.dateObj
                }
            })
                .then(response => {
                    that.showLoader = false
                    store.dispatch('notification/add', {type: 'success', message: that.$t('apiSuccessMsg')}, { root: true })  
                })
                .catch(error => {
                    that.showLoader = false
                    if (error.response.status == 422) {
                        let dateerrors = ''
                        for (var validationError of error.response.data.errors) {
                            if (validationError.PropertyName == 'StartDate') {
                                dateerrors = validationError.Error
                            } else if (validationError.PropertyName == 'EndDate') {
                                dateerrors = validationError.Error
                            }
                        }

                        this.dateErrors = dateerrors
                    } else {
                        store.dispatch('notification/add', {type: 'error', message: that.$t('optimization.serverError')}, { root: true })
                    }
                })
        }
    },
}
</script>